import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import BoletasPago from "./pages/BoletasPago";
import DeclaracionesJuradas from "./pages/DeclaracionesJuradas";
import CambiarContrasena from "./pages/CambiarContrasena";
import RecuperarContrasena from "./pages/RecuperarContrasena";
import FormularioEscolaridad from "./pages/FormularioEscolaridad";
import AdminBoletas from "./pages/AdminBoletas";
import AdminDashboard from "./pages/AdminDashboard";
import AdminControlDescargas from "./pages/AdminControlDescargas";
import AdminGestionComprobantes from "./pages/AdminGestionComprobantes";
import AdminGestionUsuarios from "./pages/AdminGestionUsuarios";
import AdminDeclaracionesJuradas from "./pages/AdminDeclaracionesJuradas";
import AdminValidarDeclaraciones from "./pages/AdminValidarDeclaraciones";
import { puede, rutaInicial } from "./permisos";

const leerSesion = () => {
  try {
    const datos = JSON.parse(sessionStorage.getItem('datos'));
    return datos && datos.length > 0 ? datos : null;
  } catch (e) {
    return null;
  }
};

// 11/08/2026 - `modulo` es opcional. Cuando se indica, la ruta ademas de
// exigir sesion comprueba que el rol del usuario conceda ese modulo. Antes
// bastaba con estar autenticado: cualquiera que supiera la URL
// /admin-gestion-usuarios llegaba a la pantalla (el backend si cortaba, pero
// la pantalla se pintaba igual y quedaba en blanco, que confunde).
const PrivateRoute = ({ component: Component, modulo, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const datos = leerSesion();
      if (!datos) return <Redirect to="/" />;
      if (modulo && !puede(datos, modulo)) return <Redirect to={rutaInicial(datos)} />;
      return <Component {...props} />;
    }}
  />
);

const PublicOnlyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const datos = leerSesion();
      if (!datos) return <Component {...props} />;
      return <Redirect to={rutaInicial(datos)} />;
    }}
  />
);

class Routes extends React.Component {
  render() {
    return (
      <Switch>
        <PublicOnlyRoute exact path="/" component={Login} />
        <Route exact path="/recuperar-contrasena" component={RecuperarContrasena} />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/cambiar-contrasena" component={CambiarContrasena} />
        <PrivateRoute exact path="/FormularioEscolaridad" component={FormularioEscolaridad} />
        <PrivateRoute path="/boletas-pago" component={BoletasPago} />
        <PrivateRoute path="/admin-dashboard" component={AdminDashboard} />
        <PrivateRoute path="/admin-boletas" modulo="BOLETAS_ADMIN" component={AdminBoletas} />
        {/* Mismo componente, pero exigiendo comprobante antes de descargar.
            Ahora es un modulo propio, asi que tambien lo puede usar el
            administrador y no solo quien tenga el rol Operador. */}
        <PrivateRoute path="/admin-boletas-comprobante" modulo="BOLETAS_COMPROBANTE" component={AdminBoletas} />
        <PrivateRoute path="/admin-control-descargas" modulo="CONTROL_DESCARGAS" component={AdminControlDescargas} />
        <PrivateRoute path="/admin-gestion-comprobantes" modulo="GESTION_COMPROBANTES" component={AdminGestionComprobantes} />
        <PrivateRoute path="/admin-gestion-usuarios" modulo="GESTION_USUARIOS" component={AdminGestionUsuarios} />
        <PrivateRoute path="/admin-declaraciones-juradas" modulo="DJ_GESTION" component={AdminDeclaracionesJuradas} />
        <PrivateRoute path="/admin-validar-declaraciones" modulo="DJ_VALIDACION" component={AdminValidarDeclaraciones} />
        <PrivateRoute path="/declaraciones-juradas" component={DeclaracionesJuradas} />
        <Route
          render={function () {
            return <h1>Pagina no encontrada</h1>;
          }}
        />
      </Switch>
    );
  }
}

export default Routes;
